import React, {useEffect, useRef, useState} from 'react';
import "./ClickReveal.sass";
import gsap from "gsap";
import renderHTML from 'react-render-html';
import apiJSON from "../../../api/apiJSON";
import CheckBox_default from "../../../icons/check_box_default.svg"
import CheckBox_selected from "../../../icons/check_box_selected.svg"
import StandardButton from "../../ui/Button/StandardButton"

const ClickReveal = ({data, completed, next, showDoneButton}) => {
    const [feedback, setFeedback] = useState(null);
    const [selectedChoice, setSelectedChoice] = useState(null)
    const [choiceIndex, setChoiceIndex] = useState(-1);
    const [scenarioIndex, setScenarioIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [tracking, setTracking] = useState([]);
    const [activityComplete, setActivityComplete] = useState(false);
    const buttonPanel = useRef(null);
    const feedbackPanel = useRef(null);
    const jsonData = apiJSON.get(data);
    const {scenarios} = jsonData;
    const scenario = scenarios[scenarioIndex];


    /*update choice selection*/
    useEffect(() => {
        let buttons = buttonPanel.current.childNodes;
        let i = 0;
        for (i = 0; i < buttons.length; i++) {
            let b = buttons[i];
            let c = scenario.choiceSets[questionIndex].choices[i];
            if (i === choiceIndex) {
                b.style.backgroundColor = c.color ? c.color : "";
                feedbackPanel.current.style.backgroundColor = c.color ? c.color : "";
            } else {
                b.style.backgroundColor = "";
            }
        }
    }, [choiceIndex])

    /*show feedback*/
    useEffect(() => {
        console.log("tweening feedback")
        if (document.querySelector(".click-reveal-feedback-panel")) {
            gsap.from(".click-reveal-feedback-panel", {x: 1200, ease: "expo", duration: 1})
        }
    }, [feedback])

    /*update tracking*/
    useEffect(() => {
        console.log("tracking useEffect()")
        let c = checkComplete();
        console.log("c:" + c);
        if (c === true) {
            setActivityComplete(true);
        }
    }, [tracking])

    /*update activityComplete*/
    useEffect(() => {
        if (activityComplete) {
            completed();
        }
    }, [activityComplete])

    /*update question*/
    useEffect(() => {
        gsap.set('.click-reveal-choice-panel', {"visibility": "visible"});
        gsap.from('.click-reveal-choice-panel', {x: 1200, duration: 1, ease: "expo"});
        let t = [];
        scenario.choiceSets[questionIndex].choices.map((choice, index) => {
            t[index] = 0
        });
        setTracking(t);

    }, [questionIndex])

    const checkComplete = () => {
        console.log("checkComplete(): tracking: " + tracking)
        return (tracking.length === 0 || tracking.includes(0) ? false : true);
    }

    const finished = () => {
        next();
    }

    const handleChoice = (index) => {
        setChoiceIndex(index);
        let t = tracking.slice();
        t[index] = 1;
        setTracking(t)

        let c = scenario.choiceSets[questionIndex].choices[index];
        if (c.feedback) {
            setFeedback(c.feedback);
        }

    };

    const isSelected = (index) => {
        return (tracking.length > 0 && tracking[index] === 1);
    }

    const handleContinue = () => {
        setFeedback(null)
        if (questionIndex + 1 >= scenario.choiceSets.length) {
            if (scenarioIndex + 1 < jsonData.scenarios.length) {
                setQuestionIndex(0)
                setScenarioIndex(scenarioIndex + 1);
            } else {
                finished();
            }
        } else {
            setQuestionIndex(questionIndex + 1)
        }
    };


    return (
        <div className="ClickReveal">
            {feedback ? (
                <div className="click-reveal-feedback-panel"
                     ref={feedbackPanel}>
                    <div className='click-reveal-feedback-panel-title'
                         style={scenario.choiceSets[questionIndex].choices[choiceIndex].textColor ? {
                             "color": scenario.choiceSets[questionIndex].choices[choiceIndex].textColor
                         } : {}}>
                        {feedback.title}
                    </div>
                    <div className="click-reveal-feedback-divider"
                         style={scenario.choiceSets[questionIndex].choices[choiceIndex].textColor ? {
                             "backgroundColor": scenario.choiceSets[questionIndex].choices[choiceIndex].textColor
                         } : {}}/>
                    <div className="click-reveal-feedback-panel-body"
                         style={scenario.choiceSets[questionIndex].choices[choiceIndex].textColor ? {
                             "color": scenario.choiceSets[questionIndex].choices[choiceIndex].textColor
                         } : {}}>
                        {renderHTML(feedback.body)}
                    </div>
                </div>
            ) : null}
            {scenario ? (
                <div className="click-reveal-choice-panel">
                    {scenario.choiceSets[questionIndex].title ? (
                        <div className="click-reveal-choice-panel-title">
                            {scenario.choiceSets[questionIndex].title}
                        </div>
                    ) : null}
                    {scenario.choiceSets[questionIndex].title && scenario.choiceSets[questionIndex].body ? (
                        <div className="click-reveal-choice-panel-divider"/>
                    ) : null}
                    {scenario.choiceSets[questionIndex].body ? (
                        <div className="click-reveal-choice-panel-body">
                            {renderHTML(scenario.choiceSets[questionIndex].body)}
                        </div>
                    ) : null}
                    <div className="click-reveal-button-panel"
                         ref={buttonPanel}>
                        {scenario.choiceSets[questionIndex].choices.map((choice, index) => (
                            <div key={"choice" + index}
                                 className={"Button choice " + (index === choiceIndex ? "selected" : "")}
                                 style={{
                                     "position": "relative",
                                     "fontSize":"1.75rem"
                                 }}
                                 onClick={() => {
                                     handleChoice(index)
                                 }}>
                                <div className="click-reveal-button-icon">
                                    <img src={isSelected(index) ? CheckBox_selected : CheckBox_default}/>
                                </div>
                                {choice.label}
                            </div>
                        ))}
                    </div>
                </div>
            ) : null
            }
            {showDoneButton &&
            <StandardButton data={"DONE"}
                            disabled={!checkComplete()}
                            callback={next}
                            style={{
                                "position": "absolute",
                                "bottom": "50px",
                                "right": 0
                            }}/>
            }
        </div>
    );
};

export default ClickReveal;